<template>
  <div class="contcaptcha">
    <div class="cont" id="conlimit">
      <div id="captcha" @mousedown="startMove" @mousemove="handleMove" @mouseup="endMove" @touchstart="startMove"
        @touchmove="handleMove" @touchend="endMove" ref="captcha" :style="{ 'background-image': 'url(' + image + ')' }">
        <div id="handle">
          <div class="text-container">
            Deslice la barra hasta que encaje la imagen
          </div>
          <span @mousedown.prevent @touchstart.prevent></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.contcaptcha {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 280px);
}

.contcaptcha .cont {
  position: relative;
  padding-left: 163px;
}

#captcha {
  --width: 400px;
  --height: 260px;
  --puzzle-width: 80px;
  --puzzle-height: 80px;
  --offset-left: var(--width) * -1;
  --puzzle-moved: -100%;
  --hadled-moved: 0px;
  /* Inicializa fuera de la imagen */

  display: block;
  width: var(--width);
  height: var(--height);
  border-radius: 4px;
  background-image: url(https://images.unsplash.com/photo-1606787366850-de6330128bfc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2700&q=80);
  background-size: cover;
  background-position: center;
  position: relative;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
}

#captcha.vertical {
  --width: 300px;
  --height: 400px;
  margin-left: -100px;
}

#captcha::before,
#captcha::after {
  position: absolute;
  content: '';
  display: block;
  width: inherit;
  height: inherit;
  background-image: inherit;
  background-size: inherit;
  background-position: inherit;

  clip-path: inset(calc((var(--height) - var(--puzzle-height)) / 2) var(--puzzle-width) calc((var(--height) - var(--puzzle-height)) / 2) calc(var(--width) - var(--puzzle-width) * 2));
  -webkit-clip-path: inset(calc((var(--height) - var(--puzzle-height)) / 2) var(--puzzle-width) calc((var(--height) - var(--puzzle-height)) / 2) calc(var(--width) - var(--puzzle-width) * 2));
}

#captcha::after {
  transform: translateX(var(--puzzle-moved));
  transition: 0.25s all ease-in-out;
}

#captcha.vertical::after {
  transform: translateY(var(--puzzle-moved));
}

#captcha:active::after {
  transition: none;
}

#captcha::before {
  background-color: rgba(0, 0, 0, 0.6);
  background-blend-mode: multiply;
}

#handle {
  width: calc(var(--width) + var(--puzzle-width) * 2);
  height: 30px;
  border-radius: 18px;
  background-color: #eee;
  position: absolute;
  bottom: -50px;
  left: calc(var(--puzzle-width) * -1);
  /* Ajusta la posición inicial horizontal del botón */
  box-shadow: inset 0px 0px 12px rgba(0, 0, 0, 0.2);
  border: 3px solid #ccc;

  display: flex;
  align-items: center;
  flex-direction: row;
}

#captcha.vertical #handle {
  width: 30px;
  height: calc(var(--height) + var(--puzzle-height) * 2);
  bottom: auto;
  left: -50px;
  flex-direction: column;
}

.text-container {
  flex: 1;
  text-align: center;
  z-index: 1;
  writing-mode: horizontal-tb;
}

#captcha.vertical .text-container {
  writing-mode: vertical-lr;
  text-align: center;
}

#handle span {
  display: block;
  width: var(--puzzle-width);
  height: inherit;
  border-radius: inherit;
  background-color: #fff;
  box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.25), 0px 2px 4px rgba(0, 0, 0, 0.3);
  position: absolute;
  cursor: move;
  transform: translateX(var(--handle-moved));
  transition: 0.25s all ease-in-out;

  z-index: 2;
}

#captcha.vertical #handle span {
  width: inherit;
  height: var(--puzzle-height);
  transform: translateY(var(--handle-moved));
}

#captcha:active #handle span {
  transition: none;
}

#captcha.passed::before,
#captcha.passed::after,
#captcha.passed #handle {
  opacity: 0;
}
</style>

<script>
import image1 from '../assets/ApoyoFinanciero.jpg';
import image2 from '../assets/Credimpulso.jpg';
import image3 from '../assets/CreditoEstudiantil.jpg';
import image4 from '../assets/IdeaDeNegocio.jpg';

export default {
  props: {
    complete: Boolean,
  },
  data() {
    return {
      shouldMove: false,
      offsetStart: 0,
      startClientPos: 0,
      buttonWidth: 0,
      image: '',
      isVertical: false,
    };
  },
  mounted() {
    window.addEventListener('resize', this.updateOrientation);
    this.updateOrientation();
    this.updateOffsets();
    this.selectRandomImage();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateOrientation);
  },
  methods: {
    updateOrientation() {
      this.isVertical = window.innerWidth < 768;
      const captcha = this.$refs.captcha;
      if (this.isVertical) {
        captcha.classList.add('vertical');
      } else {
        captcha.classList.remove('vertical');
      }
      this.updateOffsets();
    },
    updateOffsets() {
      const captcha = this.$refs.captcha;
      if (this.isVertical) {
        this.offsetStart = captcha.offsetTop;
        // captcha.style.setProperty('--moved', `-${captcha.offsetHeight + 80}px`); // Inicializa fuera de la imagen (vertical)
        captcha.style.setProperty('--puzzle-moved', `-${captcha.offsetHeight - 40}px`); // Inicializa fuera de la imagen (vertical)
      } else {
        this.offsetStart = captcha.offsetLeft;
        captcha.style.setProperty('--moved', `-${captcha.offsetWidth}px`); // Inicializa fuera de la imagen (horizontal)
      }
      this.buttonWidth = captcha.querySelector('#handle span').getBoundingClientRect().width;
    },
    selectRandomImage() {
      const images = [image1, image2, image3, image4];
      const random = Math.floor(Math.random() * images.length);
      this.image = images[random];
    },
    startMove(e) {
      this.shouldMove = true;
      this.startClientPos = this.isVertical
        ? e.touches?.[0]?.clientY || e.clientY
        : e.touches?.[0]?.clientX || e.clientX;
      console.log('startClientPos', this.startClientPos);

    },
    handleMove(e) {
      if (this.shouldMove) {
        const clientPos = this.isVertical
          ? e.touches?.[0]?.clientY || e.clientY
          : e.touches?.[0]?.clientX || e.clientX;

        const delta = clientPos - this.startClientPos;

        // Movimiento del botón (relativo)
        const movedHandle = Math.max(0, delta);

        // Movimiento del puzzle (mantener dentro de límites)
        const movedPuzzle = this.isVertical
          ? Math.max(-this.$refs.captcha.offsetHeight, Math.min(0, -this.$refs.captcha.offsetHeight + movedHandle))
          : Math.max(-this.$refs.captcha.offsetWidth, Math.min(0, -this.$refs.captcha.offsetWidth + movedHandle));

        // Aplica los valores a las variables CSS por separado
        this.$refs.captcha.style.setProperty('--handle-moved', `${movedHandle}px`);
        this.$refs.captcha.style.setProperty('--puzzle-moved', `${movedPuzzle}px`);
      }
    },
    endMove(e) {
      if (this.shouldMove) {
        const clientPos = this.isVertical
          ? e.changedTouches?.[0]?.clientY || e.clientY
          : e.changedTouches?.[0]?.clientX || e.clientX;

        const delta = clientPos - this.startClientPos;

        const movedHandle = this.isVertical
          ? Math.max(0, Math.min(this.$refs.captcha.offsetHeight, delta)) // Vertical
          : Math.max(0, Math.min(this.$refs.captcha.offsetWidth, delta)); // Horizontal

        // Ajusta los rangos en función del modo
        const validRangeStart = this.isVertical
          ? this.$refs.captcha.offsetHeight - 10 // Cerca del borde superior
          : 389;

        const validRangeEnd = this.isVertical
          ? this.$refs.captcha.offsetHeight // Margen cercano al borde superior
          : 415;

        console.log('movedHandle: ', movedHandle);
        console.log('validRangeStart: ', validRangeStart);
        console.log('validRangeEnd: ', validRangeEnd);
        
        if (movedHandle >= validRangeStart && movedHandle <= validRangeEnd) {
          this.$refs.captcha.classList.add('passed');
          this.$emit('complete', true);
        } else {
          const resetPuzzleOffset = this.isVertical
            ? `-${this.$refs.captcha.offsetHeight}px`
            : `-${this.$refs.captcha.offsetWidth}px`;

          this.$refs.captcha.style.setProperty('--puzzle-moved', resetPuzzleOffset);
          this.$refs.captcha.style.setProperty('--handle-moved', `0px`);
        }

        this.shouldMove = false;
      }
    }

  }
};
</script>
